var i = Object.defineProperty, p = Object.defineProperties;
var s = Object.getOwnPropertyDescriptors;
var t = Object.getOwnPropertySymbols;
var c = Object.prototype.hasOwnProperty, w = Object.prototype.propertyIsEnumerable;
var m = (o, e, r) => e in o ? i(o, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : o[e] = r, a = (o, e) => {
  for (var r in e || (e = {}))
    c.call(e, r) && m(o, r, e[r]);
  if (t)
    for (var r of t(e))
      w.call(e, r) && m(o, r, e[r]);
  return o;
}, f = (o, e) => p(o, s(e));
import n, { forwardRef as N } from "react";
import d from "../lib/IconBase.mjs";
import k from "../defs/NetworkX.mjs";
const l = N((o, e) => /* @__PURE__ */ n.createElement(d, f(a({ ref: e }, o), { weights: k })));
l.displayName = "NetworkX";
export {
  l as NetworkX
};
